import React from "react"
import { useSearchParams } from "react-router-dom"
import { BankElement, IndividualElement, TaxElement, EntityElement, BrandElement, BoardElement, PasswordElement, TerminalElement } from "@tap-payments/auth-jsconnect"
import { getDeploymentRegion } from "./utils"

export default function Board() {
  const [token, setToken] = React.useState("")
  const [name, setName] = React.useState<"board" | "brand" | "tax" | "bank" | "individual" | "entity" | "password" | "terminal">("board")
  const [searchParams] = useSearchParams()
  const boardId = searchParams.get("board_id")
  const configToken = searchParams.get("config_token") ?? ""
  const lang = searchParams.get("lang")
  const countryCode = searchParams.get("country_code")
  const [busCountryCode, setBusCountryCode] = React.useState(countryCode ?? "")

  const region = getDeploymentRegion()

  const onBoardButtonClick = (item: any) => {
    setToken(item.token)
    setName(item.name)
    if (item.countryCode) setBusCountryCode(item.countryCode)
  }

  if (name === "brand") {
    return (
      <BrandElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "tax") {
    return (
      <TaxElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "bank") {
    return (
      <BankElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "individual") {
    return (
      <IndividualElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "entity") {
    return (
      <EntityElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "password") {
    return (
      <PasswordElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }

  if (name === 'terminal') {
      return (
        <TerminalElement
          open={true}
          configToken={configToken}
          scope='merchant'
          merchantDomain={window.location.origin}
          publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
          appInfo={{
            name: "Tap Connect Demo"
          }}
          businessCountryCode={""}
          language={"en" as any}
          onError={(error: any) => {
            console.log(JSON.stringify({ error }))
          }}
          onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
          verifyToken={token}
          onBoardButtonClick={(item) => {
            setToken(item.token)
            setName(item.name as any)
          }}
          region={region}
        />
      )
    }

  return (
    <BoardElement
      configToken={configToken}
      appInfo={{
        name: "Tap Connect Demo"
      }}
      language={(lang as any) || "en"}
      boardId={boardId || ""}
      merchantDomain={window.location.origin}
      open={true}
      publicKey='pk_test_lat64TEDSvHrUOYAxVRe28PQ'
      scope='merchant'
      region={region}
      onError={(error: any) => console.log("error", JSON.stringify({ error }))}
      onFlowCompleted={(res: any) => console.log("onFlowCompleted", JSON.stringify(res))}
      businessCountryCode={busCountryCode ?? "SA"}
      onBoardButtonClick={onBoardButtonClick}
      onBoardCompleted={() => console.log("onBoardCompleted")}
      onReady={() => console.log("onReady")}
      onStepCompleted={(name, data) => console.log("onStepCompleted", name, data)}
    />
  )
}
